export const tagTypeOrder: { [key in string]: number } = {
  system: 1,
  chain: 2,
  user: 3,
};
